import { SvgIcon, SvgIconProps } from '@mui/material'

export function Write(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M17.689 1.42a.75.75 0 0 1 1.06 0l4.243 4.243a.75.75 0 0 1 0 1.061L7.436 22.28a.75.75 0 0 1-.53.22H2.662a.75.75 0 0 1-.75-.75v-4.243a.75.75 0 0 1 .22-.53L17.688 1.421Zm.53 1.592L3.413 17.818V21h3.182L21.4 6.194l-3.182-3.182Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.446 5.663a.75.75 0 0 1 1.06 0l4.243 4.243a.75.75 0 0 1-1.06 1.06l-4.243-4.242a.75.75 0 0 1 0-1.06Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default Write
